import { Stack, Button, Table, Form, Badge } from "react-bootstrap";
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';


function addClass (propClasses, className) {
    var classes = "";
    if(propClasses != null){
        var arr = propClasses.split(" ").map(function(value) {
            return value.trim();
        });
        var isIncluded = arr.includes(className.trim());
        if(isIncluded){
            classes = propClasses;
        }
        else{
            classes = propClasses.concat(" " + className);
        }
    }
    else{
        classes = className;
    }

    return classes;
}

function ContextAwareToggle({ children, eventKey, callback }) {
    const { activeEventKey } = useContext(AccordionContext);

    const PINK = 'rgba(255, 192, 203, 0.6)';
    const BLUE = 'rgba(0, 0, 255, 0.6)';

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey),
    );
  
    const isCurrentEventKey = activeEventKey === eventKey;
  
    return (
        <button
            type="button"
            className="accordian-header-btn"
            /*style={{ backgroundColor: isCurrentEventKey ? PINK : BLUE }}*/
            onClick={decoratedOnClick}
        >
            {children}
        </button>
    );
  }

export const AccordianHeaderLevel1 = (props) => {
    var classes = addClass(props.className,"level1");
    return (
        <Accordion.Header className={classes}>
            <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="19.5" cy="19.5" r="18.5" fill="white" stroke="#154568" stroke-width="2"/>
                <path d="M19.8337 13.1549L10.9315 22.0571L13.0235 24.1491L19.8337 17.3538L26.6438 24.1491L28.7359 22.0571L19.8337 13.1549Z" fill="#154568"/>
            </svg>
            <span>{props.label}</span>
        </Accordion.Header>
    )
}
export const AccordianHeaderLevel2 = (props) => {
    var classes = addClass(props.className,"level2");
    return (
        <Accordion.Header className={classes}>
            <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="19.5" cy="19.5" r="18.5" fill="white" stroke="#154568" stroke-width="2"/>
                <path d="M19.8337 13.1549L10.9315 22.0571L13.0235 24.1491L19.8337 17.3538L26.6438 24.1491L28.7359 22.0571L19.8337 13.1549Z" fill="#154568"/>
            </svg>
            <span>{props.label}</span>
        </Accordion.Header>
    )
}

export const TextButton = (props) => {
    var classes = addClass(props.className,"text-button");

    return (
        <Button {...props} className={classes}>
            <div>{props.content}</div>
        </Button>
    )
}

export const IconTextButton = (props) => {
    var classes = addClass(props.className,"icon-text-button");

    return (
        <Button {...props} className={classes}>
          <Stack direction="horizontal" gap={2}>
            <div className="buttonIcon">
              {props.icon()}
            </div>
            <div className="buttonText">
              <>{props.content}</>
            </div>
          </Stack>
        </Button>
    )
}

export const IconButton = (props) => {
    var classes = addClass(props.className,"icon-button");

    return (
        <Button {...props} className={classes}>
            <div className="buttonIcon">
              {props.icon()}
            </div>
        </Button>
    )
}


export const BackToTopButton = (props) => {
    var classes = addClass(props.className,"back-to-top-button");
    var allClasses = classes + " " + props.fadeClass;
    return (
        <Button variant={props.variant} onClick={props.onClick} className={allClasses}>
          <Stack direction="horizontal" gap={2}>
            <div className="buttonText">
              <>{props.content}</>
            </div>
            <div className="buttonIcon">
              {props.icon()}
            </div>
          </Stack>
        </Button>
    )
}

export const NotificationButton = (props) => {
    var classes = addClass(props.className,"notification-button");

    return (
        <Button {...props} className={classes}>
            <div className="notificationDot">

            </div>
            <div className="buttonIcon">
              {props.icon()}
            </div>
            
        </Button>
    )
}

export const TableIconTextButton = (props) => {
    var classes = addClass(props.className,"table-icon-text-button");

    return (
        <Button {...props} className={classes}>
          {/*<Stack direction="horizontal" >
            <div className="buttonIcon">
              {props.icon()}
    </div>*/}
            <div className="buttonText text-start">
              <>{props.content}</>
            </div>
            
          {/*</Stack>*/}
        </Button>
    )
}